
import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router';

import Routes from '../Routes';

const LoggedPage = (props) => {

    const token = useSelector(state => {
        return state.auth.data ? state.auth.data.user.token : null;
    });
    const loading = useSelector(state => {
        return state.auth.loading;
    });

    if (!loading && (!token)) {
        return <Redirect to="/login" />
    }

    if (!loading) {
        return <Routes routes={props.routes} />
    } else {
        return <div>Nahrávám...</div>
    }
}

export default LoggedPage;
